"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enumDataConstants = exports.enumCheckboxState = void 0;

/**
 * @desc
 * Checkbox states.
 *
 * @enum
 *
 * @type {{UNCHECKED: number, CHECKED: number, INDETERMINATE: number}}
 */
var enumCheckboxState = {
  UNCHECKED: 0,
  CHECKED: 1,
  INDETERMINATE: 2
};
/**
 * @desc
 * Data constants.
 *
 * @enum
 *
 * @type {{CHECKED: string, EXPANDED: string}}
 */

exports.enumCheckboxState = enumCheckboxState;
var enumDataConstants = {
  CHECKED: 'checked',
  EXPANDED: 'expanded'
};
exports.enumDataConstants = enumDataConstants;
//# sourceMappingURL=constants.js.map